import type { NomIcone } from './ui'
import type { Cles } from './i18n'

/**
 * Le référentiel des équipements — **une seule liste**, citée par la publication et par la
 * recherche.
 *
 * Elle vivait dans `ecrans/Publication.tsx`, avec ses libellés écrits en français dans le
 * fichier. Deux défauts, et non un : la feuille de filtres n'avait aucun moyen de proposer les
 * mêmes codes que l'assistant de publication — donc de filtrer sur ce qu'on peut déclarer — et
 * les libellés échappaient à l'i18n, ce que la règle 1 du §6 de la conception L10 interdit.
 *
 * **Les codes sont le contrat.** Ce sont eux que la validation serveur consulte et que
 * `amenityCodes` transporte, dans la query string comme dans une recherche enregistrée. On en
 * ajoute ; on n'en renomme aucun, sous peine de détacher les annonces déjà publiées et les
 * recherches déjà gardées.
 */
export interface Equipement {
  code: string
  /** La clé i18n du libellé — jamais le libellé lui-même. */
  libelle: Cles
  /**
   * Le pictogramme — ticket fo-annonce-09.
   *
   * Il vit ICI et non dans la fiche : deux écrans affichent ces équipements, et un tableau de
   * correspondance écrit deux fois aurait fini par montrer une machine à laver ici et une coche
   * là. Le référentiel porte déjà le code et le libellé ; il porte donc aussi son image.
   */
  icone: NomIcone
}

export const EQUIPEMENTS: readonly Equipement[] = [
  { code: 'WIFI', libelle: 'equipementWifi', icone: 'wifi' },
  { code: 'WATER_HEATER', libelle: 'equipementChauffeEau', icone: 'chauffeEau' },
  { code: 'WASHING_MACHINE', libelle: 'equipementMachineALaver', icone: 'machineALaver' },
  { code: 'FITTED_KITCHEN', libelle: 'equipementCuisineEquipee', icone: 'cuisine' },
  { code: 'PARKING', libelle: 'equipementParking', icone: 'parking' },
  { code: 'CONCIERGE', libelle: 'equipementConcierge', icone: 'concierge' },
  { code: 'AIR_CONDITIONING', libelle: 'equipementClimatisation', icone: 'climatisation' },
]
